module.exports = __webpack_public_path__ + "static/dev-career-newsletter-8622384a7da1e73fee4086939fd676ed.png";